/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { classNames as r } from "@progress/kendo-react-common";
class t extends e.PureComponent {
  /**
   * @hidden
   */
  render() {
    return /* @__PURE__ */ e.createElement("div", { className: r("k-separator", this.props.className) });
  }
}
export {
  t as ToolbarSeparator
};
